<div class="event-response-tags">
  <div class="table">
    <div class="applied-tags-container" *ngIf="calendarEventResponse && tagGroups && tagGroups.length > 0">
      <app-applied-tag-group-table *ngFor="let group of tagGroups" [group]="group" [target]="calendarEventResponse"
        [campaignId]="campaignId" class="applied-tag-group">
      </app-applied-tag-group-table>
    </div>
  </div>
</div>
